import React from "react";

import './separator.css';

export const Separator = () => {
  return (
    <div className='separator'></div>
  )
}
